import { useEffect } from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'

import { MonomerErrorBoundary } from '~/components/MonomerErrorBoundary'
import type { MultiFrontendContext } from '~/core/MultiFrontendContext'
import BulkExportCultureMetadataPage from './BulkExportCultureMetadata/BulkExportCultureMetadataPage'
import Dashboard from './Dashboard'
import ManualPassagePlatesPage from './ManualPassagePlates/ManualPassagePlatesPage'
import cs from './monitor.scss'

const MonitorRoutes = ({
  frontendContext,
}: {
  frontendContext: MultiFrontendContext
}) => {
  const match = useRouteMatch()

  useEffect(() => {
    if (frontendContext.deploymentMode === 'automation') {
      window.location.href = `${frontendContext.cloudFrontend}/monitor`
    }
  }, [frontendContext])

  if (frontendContext.deploymentMode === 'automation') {
    return <div className={cs.routeErrorContainer}>Redirecting to Monomer Cloud...</div>
  }

  const enabledPages = frontendContext.orgMetadata.enabledPages ?? []
  if (!(enabledPages === 'all' || enabledPages.includes('monitor'))) {
    return (
      <div className={cs.routeErrorContainer}>
        You don't have access to this Culture Monitor page. If this is not expected,
        contact your Monomer support team.
      </div>
    )
  }

  return (
    <MonomerErrorBoundary>
      <div className={cs.monitorRoutes}>
        <Switch>
          <Route
            exact
            path={match.path}
            render={() => <Redirect to={`${match.path}/dashboard`} />}
          />
          <Route exact path={`${match.path}/dashboard`} render={() => <Dashboard />} />
          <Route
            exact
            path={`${match.path}/bulk-export-culture-metadata`}
            render={() => <BulkExportCultureMetadataPage />}
          />
          <Route
            exact
            path={`${match.path}/manual-passage-plates`}
            render={() => <ManualPassagePlatesPage />}
          />
        </Switch>
      </div>
    </MonomerErrorBoundary>
  )
}

export default MonitorRoutes
